import { Box, Button, Container, Typography } from "@material-ui/core";
import LanguageIcon from "@material-ui/icons/Language";
import { makeStyles } from "@material-ui/styles";
import React, { useState } from "react";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import {footerIDs} from "../../qaIDs.json"

const useStyles = makeStyles(theme => ({
  wrapper: {
    backgroundColor: "#fff",
    marginTop: 3,
    [theme.breakpoints.down("md")]: {
      marginTop: 0
    }
  },
  root: {
    height: theme.spacing(15),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      height: theme.spacing(25.5),
      justifyContent: "center",
      alignItems: "flex-start",
      flexDirection: "column",
      paddingBottom: theme.spacing(8)
    }
  },
  textTertiary: {
    color: "#B6B6B6",
    [theme.breakpoints.down("md")]: {
      order: "2",
      fontSize: "0.875rem",
      paddingLeft: theme.spacing(1)
    }
  },
  btn: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: "14px",
    textTransform: "none",
    [theme.breakpoints.down("md")]: {
      order: "1",
      marginBottom: theme.spacing(3.25)
    }
  },
  icon: {
    marginRight: theme.spacing(1)
  }
}));

const currentYear = new Date().getFullYear();
const RTCopyrightText = `© ${currentYear} Routetitan Inc. All rights reserved.`;

export default function Footer({
  language,
  changeLanguage
}: {
  language: string;
  changeLanguage: (lng: string) => void;
}) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<null | Element>(null);

  const handleClick = (event: React.SyntheticEvent<Element>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.wrapper}>
      <Container>
        <div className={classes.root}>
          <Typography className={classes.textTertiary} id={footerIDs.footerCopyright}>
            {RTCopyrightText}
          </Typography>
          <Button
            onClick={handleClick}
            className={classes.btn}
            color={undefined}
            id={footerIDs.footerLanguageButton}
          >
            <LanguageIcon className={classes.icon} color="info" />
            {language === "nl" ? "Nederlands" : language === "de" ? "Deutsch" : "English"}
          </Button>
          <LanguageSelector
            anchorEl={anchorEl}
            handleClose={handleClose}
            language={language}
            setLanguage={changeLanguage}
            menuProps={{
              anchorOrigin: { vertical: "top", horizontal: "right" },
              transformOrigin: { vertical: "bottom", horizontal: "right" }
            }}
          />
        </div>
      </Container>
    </div>
  );
}
